import { Step, StepLabel, Stepper } from '@material-ui/core';
import React from 'react';
import currentActiveStep from '../../Profile/AccountSetup/utils/currentActiveStep';
import { Link } from 'react-router-dom';

let steps = [1, 2, 3];
export default function AccountStepper({
	title = 'ACCOUNT SETUP',
	error = '',
	exclaimation = false,
	loading = false,
	approved = false,
	redirectToKyc,
	redirectTodwollaPlaid,
	toDashBoard,
	otherProps,
	pending = false,
	hasWallet = false,
	submission_date = false,
	data = {}
}) {
	const { active_step, message } = currentActiveStep(
		data,
		exclaimation,
		loading,
		hasWallet,
		submission_date,
		pending,
		approved
	);

	const handleLink = e => {
		e.preventDefault();

		if (!hasWallet) {
			redirectTodwollaPlaid();
			return;
		} else if (data?.kyc_status === 'Approved') {
			toDashBoard();
			return;
		} else if (
			hasWallet &&
			(data?.kyc_status === 'Not Yet Submitted' ||
				(data?.kyc_status === 'Rejected' &&
					!data?.send_email_resubmission_result &&
					!data.kyc_resubmission_date) ||
				(data?.kyc_status === 'Rejected' && data?.send_email_resubmission_result && data.kyc_resubmission_date))
		) {
			redirectToKyc();
			return;
		}
	};

	const isStepFailed = step => {
		if (data?.kyc_status === 'Rejected' && data?.submission_date) {
			return step === 2;
		}
		return step === 1;
	};

	return (
		<>
			<h6 className="account_setup_title">{title}</h6>
			<Stepper
				activeStep={error ? 0 : active_step}
				className={`account_steps ${loading ? 'placeholder' : ''} `}
				{...otherProps}>
				{steps.map((label, index) =>
					exclaimation && isStepFailed(index) ? (
						<Step key={label} className={`${exclaimation ? 'skip_step' : ' '}`}>
							<StepLabel error={true}>{}</StepLabel>
						</Step>
					) : (
						<Step key={label}>
							<StepLabel>{}</StepLabel>
						</Step>
					)
				)}
			</Stepper>
			{/* {pending ? null : ( */}
			<Link href={'#kyc'} disabled={!!error} onClick={e => handleLink(e)} className="account_setup_steps">
				{error ? (
					<span style={{ color: 'red' }}>{error + ' unable to retreive data'}</span>
				) : (
					<span>{message} &gt;</span>
				)}
			</Link>
			{/* )} */}
		</>
	);
}
